import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import {
  Button,
  Container,
  SuccessMessage,
} from '../../../common/form';

import { propTypes, defaultProps } from '../prop-types';
import useBannerStore from './state-hook';
import {
  createBanner,
  updateBanner,
} from '../../../../../services/lwadmin/homepage/banner-service';

import withNameFileUpload from '../../../common/file-upload';
import withNameInput from '../../../common/input';

const Name = withNameInput('banner', 'name', useBannerStore);
const Image = withNameFileUpload('banner', 'image', useBannerStore, 'image/png, image/jpeg', 'Image');
const Headline = withNameInput('banner', 'headline', useBannerStore);
const Byline = withNameInput('banner', 'byline', useBannerStore);
const RegisterButtonCopy = withNameInput('banner', 'registerButtonCopy', useBannerStore, 'Register Button Copy');

const SContainer = styled(Container)`
  padding-bottom: 40px;
`;

export default function Form(props) {
  const [saving, setSaving] = React.useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);

  const set = useBannerStore(state => state.set);
  const banner = useBannerStore(state => state.banner);

  const { id } = banner;

  useChangeAwareEffect(({ isMount }) => {
    isMount && set(state => {
      state.banner = (props || defaultProps).banner;
    });
  }, {});

  const saveBanner = e => {
    e && e.preventDefault();

    setSaving(true);

    const payload = {
      name: banner.name,
      image: banner.image,
      headline: banner.headline,
      byline: banner.byline,
      register_button_copy: banner.registerButtonCopy,
    };

    const createOrUpdate = id
      ? updateBanner(id, payload)
      : createBanner(payload);

    createOrUpdate.then(resp => {
      setSaving(false);
      setShowSuccessMessage(true);

      const createdId = _.get(resp, 'data.id');
      if (createdId) {
        set(state => {
          state.banner.id = createdId;
        });
      }

      set(state => {
        state.errors = {};
      });
    }).catch(error => {
      setSaving(false);
      setShowSuccessMessage(false);

      set(state => {
        state.errors = _.get(error, 'response.data', {});
      });

      setSaving(false);
    });
  };

  return (
    <SContainer>
      {showSuccessMessage && (
        <SuccessMessage>
          Banner successfully saved
        </SuccessMessage>
      )}
      <Name />
      <Headline />
      <Byline />
      <Image />
      <RegisterButtonCopy />
      <Button className="btn btn-primary" onClick={saveBanner} disabled={saving}>
        {saving ? 'Saving' : 'Save'}
      </Button>
    </SContainer>
  );
}

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;
